import React from 'react';
export function SolutionSection() {
  return <section className="bg-gradient-to-b from-dark-900 via-[#141000] to-[#1a1500] py-[80px] px-5 text-center" data-id="element-437">
      <div className="max-w-[1100px] mx-auto" data-id="element-438">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-alphaGold" data-id="element-439">
          La Solución Ya Existe —<br data-id="element-440" />Y Está en AlphaFit
        </h2>

        <div className="max-w-[800px] mx-auto text-[1.1rem] leading-[1.9] text-[#ccc] mt-8" data-id="element-441">
          <p data-id="element-442">
            No necesitás gastar fortunas en marcas importadas ni esperar semanas
            para que llegue tu pedido.
            <strong className="text-white" data-id="element-443"> Cibeles y Profit</strong> son las
            marcas de suplementos de calidad certificada disponibles ahora
            mismo, en tu ciudad, a precios que tienen sentido.
          </p>
        </div>

        <div className="bg-alphaGold/10 border border-alphaGold/30 rounded-md p-[30px] my-[40px] mx-auto max-w-[700px] text-[1.2rem] font-bold text-white leading-[1.6]" data-id="element-444">
          "Con la suplementación correcta, tu cuerpo tiene todo lo que necesita
          para crecer, recuperarse y rendir al máximo — entrenamiento tras
          entrenamiento."
        </div>

        <div className="max-w-[800px] mx-auto text-[1.1rem] leading-[1.9] text-[#ccc]" data-id="element-445">
          <p data-id="element-446">
            En <strong className="text-white" data-id="element-447">AlphaFit</strong> creemos en la
            calidad sin excusas. Cada producto está formulado para resultados
            reales — no promesas vacías. Y hoy, con{' '}
            <strong className="text-white" data-id="element-448">20% OFF</strong>, no hay razón para
            esperar.
          </p>
        </div>
      </div>
    </section>;
}